// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__J7hdI","titleContainer":"Projects_titleContainer__-I8L2","projectsGrid":"Projects_projectsGrid__cgydT"};